if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;

        const mediaId = this.openedBy.getAttribute('data-media-id');
        if (!mediaId) return;

        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (container) {
          requestAnimationFrame(() => {
            if (window.matchMedia('(max-width: 749px)').matches) {
              container.scrollTo({ top: 0, left: 0, behavior: 'auto' });
            } else {
              activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
              const mediaWidth = activeMedia.getBoundingClientRect().width;
              container.scrollLeft = Math.max(0, (mediaWidth - container.clientWidth) / 2);
            }
          });
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
